"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./divider.css");
var Divider = function (_a) {
    var size = _a.size, _b = _a.appearance, appearance = _b === void 0 ? 'normal' : _b, className = _a.className, _c = _a.dataTest, dataTest = _c === void 0 ? 'divider' : _c, other = tslib_1.__rest(_a, ["size", "appearance", "className", "dataTest"]);
    var classes = (0, classnames_1.default)('dsc-divider', size === 'medium' || size === 'large' ? "is-".concat(size) : null, appearance !== 'normal' ? "is-".concat(appearance) : null, className);
    return (0, jsx_runtime_1.jsx)("hr", tslib_1.__assign({}, other, { className: classes, "data-test": dataTest }));
};
exports.Divider = Divider;
exports.Divider.displayName = 'Divider';
//# sourceMappingURL=divider.js.map